import OrgLogo from "assets/img/ORG.png";
import sconexLogo from "assets/img/sconex.jpeg";
import { format } from "date-fns";

const handlePrintReport = (tableData, selectedScenario) => {
  const orgImg = new Image();
  orgImg.src = OrgLogo;
  const sconexImg = new Image();
  sconexImg.src = sconexLogo;

  const currentDate = new Date();
  const formattedDate = format(currentDate, "iii, MMM a");
  const timezoneOffset = currentDate.getTimezoneOffset();
  const offsetHours = Math.abs(Math.floor(timezoneOffset / 60));
  const offsetMinutes = Math.abs(timezoneOffset % 60);
  const offsetSign = timezoneOffset > 0 ? "-" : "+";
  const formattedOffset = `${offsetSign}${offsetHours.toString().padStart(2, "0")}${offsetMinutes.toString().padStart(2, "0")}`;
  const formattedDateTime = `Report generated on ${formattedDate} ${formattedOffset}`;

  const printContent = () => {
    const printWindow = window.open("", "_blank");
    const tableContent = `
      <html>
        <head>
          <title>Image Summary Table</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 20px; 
              padding-bottom: 60px;
            }
            .container { 
              display: flex; 
              flex-direction: column; 
              min-height: 100%; 
            }
            table { 
              border-collapse: collapse; 
              width: 100%; 
              margin-bottom: 40px;
            }
            th, td { 
              border: 1px solid black; 
              padding: 8px; 
              text-align: left; 
            }
            th { 
              background-color: #F40009; 
            }
            .header { 
              display: flex; 
              justify-content: space-between; 
              align-items: flex-start; 
              margin-bottom: 20px; 
            }
            .header-left { 
              display: flex; 
              flex-direction: column; 
              align-items: flex-start; 
            }
            .header-right { 
              display: flex; 
              flex-direction: column; 
              align-items: flex-end; 
            }
            .header-right img { 
              width: 120px; 
              height: auto; 
              display: block; 
            }
            .store-id { 
              font-size: 16px; 
              font-weight: bold; 
              color: #333; 
              margin-top: 10px; 
            }
            .date-time { 
              font-weight: bold;
              font-size: 14px; 
              color: #333; 
              margin-top: 5px; 
            }
            .image-fallback { 
              width: 120px; 
              height: 60px; 
              background-color: #f0f0f0; 
              display: flex; 
              align-items: center; 
              justify-content: center; 
              color: #666; 
              font-size: 14px; 
              text-align: center; 
            }
            .footer { 
              display: flex; 
              align-items: center; 
              justify-content: flex-start; 
              padding: 20px 30px; 
              gap: 12px; 
              width: 100%; 
              background-color: #fff; 
              margin-top: auto;
            }
            .footer img { 
              height: 24px; 
              width: auto; 
            }
            .footer-text { 
              color: black; 
              font-size: 16px; 
            }
            @media print {
              .footer { 
                position: fixed; 
                bottom: 0; 
                left: 0; 
                right: 0; 
              }
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <div class="header-left">
                <h1>Image Summary Report</h1>
                <span class="date-time">${formattedDateTime}</span>
              </div>
              <div class="header-right">
                <img src="${OrgLogo}" alt="ORG Logo" onerror="this.style.display='none'; this.nextSibling.style.display='block';" />
                <div class="image-fallback" style="display: none;">Logo Not Available</div>
                <span class="store-id">StoreID: ${selectedScenario}</span>
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th>S No</th>
                  <th>StoreID</th>
                  <th>Image Name</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                ${tableData
                  .map(
                    (row) =>
                      `<tr>
                        <td>${row.sno}</td>
                        <td>${row.storeId}</td>
                        <td>${row.imageName}</td>
                        <td>${row.count}</td>
                      </tr>`
                  )
                  .join("")}
              </tbody>
            </table>
            <div class="footer">
              <span class="footer-text">Copyright © 2025</span>
              <img src="${sconexLogo}" alt="SCONEX Logo" />
              <span class="footer-text">| Confidential</span>
            </div>
          </div>
        </body>
      </html>
    `;
    printWindow.document.write(tableContent);
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.print();
    };
  };

  let imagesLoaded = 0;
  const onImageLoad = () => {
    imagesLoaded++;
    if (imagesLoaded < 2) return;
    printContent();
  };

  orgImg.onload = onImageLoad;
  sconexImg.onload = onImageLoad;
  orgImg.onerror = () => {
    console.error("Failed to load OrgLogo image");
    imagesLoaded++;
    if (imagesLoaded === 2) {
      printContent();
    }
  };
  sconexImg.onerror = () => {
    console.error("Failed to load sconexLogo image");
    imagesLoaded++;
    if (imagesLoaded === 2) {
      printContent();
    }
  };
};

export default handlePrintReport;